export default "__VITE_ASSET__C9g2N9$u__"